export class FixtureDetails {

    constructor(json: any = null) {
        if (json) {
            // Map the json object to 'this' objects properties.
            Object.assign(this, json);

        }
    }

    public Id: number;
    public Name: string;
    public Description: string;
    public ThemeName: string;
    public ThemeDescription: string;
    public FixtureType: number;
    public Theme: FixtureColorDetails;
    public PreviewTimeout: number = 1;
}

export class FixtureColorDetails {

    constructor(json: any = null) {
        if (json) {
            // Map the json object to 'this' objects properties.
            Object.assign(this, json);
        }
    }

    public ThemeB: number;
    public ThemeBeamAngle: number
    public ThemeCool: number;
    public ThemeDimming: number;
    public ThemeEndDay: number;
    public ThemeEndMonth: number;
    public ThemeEndYear: number;
    public ThemeFade: number;
    public ThemeG: number;
    public ThemeR: number;
    public ThemeStartDay: number;
    public ThemeStartMonth: number;
    public ThemeStartYear: number;
    public ThemeWarm: number;

}
